










import { Component, Vue, Prop } from 'vue-property-decorator';
import ProfiePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
@Component({
  components: {
    placeholder: ProfiePlaceholder,
  },
})
export default class Placeholder extends Vue {
  @Prop({ default: '' }) timeSheetType;
  @Prop({ default: true }) canShowAddLink;
  @Prop({ default: () => {} }) onLinkClick;
}
